define('util/probablyGuid',[],function() {
    "use strict";
    //NOTE: Due to limitations on javascripts ability to generate random numbers, this may not be a true GUID
    //so this isn't recommended for intensive uses, adapted from: http://guid.us/GUID/JavaScript

    //Get a true cryptographic random, not supported <IE11
    function cryptoRandom() {
        var array = new Uint32Array(1); //array to hold a single random value
        window.crypto.getRandomValues(array); //fills array with a random number up to 2^32
        return array[0]/Math.pow(2,32); //normalize to be in [0, 1)
    }

    var rand = (window.crypto) ? cryptoRandom : Math.random;

    function probablyGuid() {

        /*jshint bitwise:false */
        function S4() {
            return (((1+rand())*0x10000)|0).toString(16).substring(1);
        }
        
        //specified by the UUID v4 standard, 3rd block begins with 4
        var X4 = "4"+S4().substr(0,3);

        //specified by the UUID standard, 4th block begins with 8,9,a, or b.
        var Y4 = (~~(rand()*4) + 8).toString(16) + S4().substr(0, 3);

        return (S4() + S4() + "-" + S4() + "-" + X4 + "-" + Y4 + "-" + S4() + S4() + S4()).toLowerCase();
    }

    return probablyGuid;
});
